
<div style="width: 100%; height: 100%;">
  <canvas #canvas style="width: 100%; height:100%"></canvas>
</div>
